module.exports = __webpack_public_path__ + "img/firma_template2.65e3d18.svg";